export enum Membership {
	INVITE = 'invite',
	KNOCK = 'knock',
	JOIN = 'join',
	LEAVE = 'leave',
	BAN = 'ban'
}

export enum StateEvent {
	ROOM_CANONICAL_ALIAS = 'm.room.canonical_alias',
	ROOM_CREATE = 'm.room.create',
	ROOM_JOIN_RULES = 'm.room.join_rules',
	ROOM_MEMBER = 'm.room.member',
	ROOM_THIRD_PARTY_INVITE = 'm.room.third_party_invite',
	ROOM_POWER_LEVELS = 'm.room.power_levels',
	ROOM_NAME = 'm.room.name',
	ROOM_TOPIC = 'm.room.topic',
	ROOM_AVATAR = 'm.room.avatar',
	ROOM_PINNED_EVENTS = 'm.room.pinned_events',
	ROOM_ENCRYPTION = 'm.room.encryption',
	ROOM_HISTORY_VISIBILITY = 'm.room.history_visibility',
	ROOM_GUEST_ACCESS = 'm.room.guest_access',
	ROOM_SERVER_ACL = 'm.room.server_acl',
	ROOM_TOMBSTONE = 'm.room.tombstone',
	GROUP_CALL_PREFIX = 'org.matrix.msc3401.call',
	GROUP_CALL_MEMBER_PREFIX = 'org.matrix.msc3401.call.member',

	SPACE_CHILD = 'm.space.child',
	SPACE_PARENT = 'm.space.parent',

	PONIES_ROOM_EMOTES = 'im.ponies.room_emotes',
	POWER_LEVEL_TAGS = 'in.cinny.room.power_level_tags'
}

export enum MessageEvent {
	ROOM_MESSAGE = 'm.room.message',
	ROOM_MESSAGE_ENCRYPTED = 'm.room.encrypted',
	STICKER = 'm.sticker',
	ROOM_REDACTION = 'm.room.redaction',
	REACTION = 'm.reaction'
}

export enum RoomType {
	SPACE = 'm.space',
	CALL = 'org.matrix.msc3417.call'
}

export enum NotificationType {
	DEFAULT = 'default',
	ALL_MESSAGES = 'all_messages',
	MENTIONS_AND_KEYWORDS = 'mentions_and_keywords',
	MUTE = 'mute'
}

export enum AccountDataEvent {
	PUSH_RULES = 'm.push_rules',
	DIRECT = 'm.direct',
	IGNORED_USER_LIST = 'm.ignored_user_list',

	CINNY_SPACES = 'in.cinny.spaces',

	ELEMENT_RECENT_EMOJI = 'io.element.recent_emoji',

	PONIES_USER_EMOTES = 'im.ponies.user_emotes',
	PONIES_EMOTE_ROOMS = 'im.ponies.emote_rooms',

	SECRET_STORAGE_DEFAULT_KEY = 'm.secret_storage.default_key',

	CROSS_SIGNING_MASTER = 'm.cross_signing.master',
	CROSS_SIGNING_SELF = 'm.cross_signing.self',
	CROSS_SIGNING_USER = 'm.cross_signing.user',
	MEGOLM_BACKUP_V1 = 'm.megolm_backup.v1'
}

export enum AutoDiscoveryAction {
	PROMPT = 'PROMPT',
	IGNORE = 'IGNORE',
	FAIL_PROMPT = 'FAIL_PROMPT',
	FAIL_ERROR = 'FAIL_ERROR'
}
